(function () {

  var KLAVIYO_ID = 'QUfT93';

  var INTENT = [
    { value: 'INTENT_BRUNCH',   label: 'Brunch' },
    { value: 'INTENT_WORK',     label: 'Work' },
    { value: 'INTENT_WEEKEND',  label: 'Weekend' },
    { value: 'INTENT_EVENT',    label: 'Going Out' },
    { value: 'INTENT_TRAVEL',   label: 'Travel' },
    { value: 'INTENT_EVERYDAY', label: 'Everyday' },
  ];

  var INTENT_OCCASION_MAP = {
    INTENT_BRUNCH:   'Brunch',
    INTENT_WORK:      'Professional',
    INTENT_WEEKEND:   'Weekend',
    INTENT_EVENT:     'Evening',
    INTENT_TRAVEL:    'Travel',
    INTENT_EVERYDAY:  'Everyday'
  };

  var TRAVEL_HELP = [
    { value: 'yes', label: 'Yes, please' },
    { value: 'no',  label: "No, I'm good" },
  ];

  var LOOK_PREF = [
    { value: 'LOOK_CASUAL',   label: 'Casual' },
    { value: 'LOOK_FEMININE', label: 'Feminine' },
    { value: 'LOOK_CLASSIC',  label: 'Classic' },
    { value: 'LOOK_SEXY',     label: 'A little sexy' },
    { value: 'LOOK_SURPRISE', label: 'Surprise me' },
  ];

  var STYLE_PREF = [
    { value: 'STYLE_SIMPLE',      label: 'Keep it simple' },
    { value: 'STYLE_DRESSED_UP',  label: 'A little more dressed up' },
    { value: 'STYLE_STANDOUT',    label: 'Make it stand out' },
  ];

  var CONTACT_PREF = [
    { value: 'CONTACT_WHATSAPP', label: 'WhatsApp' },
    { value: 'CONTACT_EMAIL',    label: 'Email' },
  ];

  function isLookContext(container) {
    if (container.hasAttribute('data-sfy-standalone')) return true;
    if (document.getElementById('complete-look-block')) return true;
    if (document.querySelector('[data-look-page]')) return true;
    return false;
  }

  function digitsOnly(str) {
    return (str || '').replace(/[^\d]/g, '');
  }

  function ga4(name, params) {
    try { if (typeof gtag === 'function') gtag('event', name, params || {}); } catch (e) {}
  }

  function viewed() {
    if (sessionStorage.getItem('sfy_viewed')) return;
    sessionStorage.setItem('sfy_viewed', '1');
    ga4('sfy_form_viewed', { page: window.location.href });
  }

  function post(endpoint, body) {
    return fetch('https://a.klaviyo.com/client/' + endpoint + '/?company_id=' + KLAVIYO_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
      body: JSON.stringify(body)
    });
  }

  // Primary completion submit: email + occasion + Q2 + Q3 + travel-help + recommended_look_handle.
  // Fires exactly once per questionnaire completion.
  function submit(data) {
    var now = new Date().toISOString();
    var profileProps = {
      styled_for_you_occasion: data.occasion,
      styled_for_you_look_preference: data.lookPref,
      styled_for_you_style_preference: data.stylePref,
      styled_for_you_recommended_look: data.recommendedLookHandle,
      styled_for_you_source: window.location.href,
      styled_for_you_date: now,
      styled_for_you_completed: true
    };
    if (data.travelHelp) profileProps.styled_for_you_travel_packing_help = data.travelHelp;

    var profilePayload = { data: { type: 'profile', attributes: { email: data.email, properties: profileProps } } };
    var eventPayload = { data: { type: 'event', attributes: {
      metric: { data: { type: 'metric', attributes: { name: 'Styled For You Completed' } } },
      profile: { data: { type: 'profile', attributes: { email: data.email } } },
      properties: {
        intent: data.occasion,
        occasion: data.occasion,
        look_preference: data.lookPref,
        style_preference: data.stylePref,
        recommended_look_handle: data.recommendedLookHandle,
        travel_packing_help: data.travelHelp || null,
        source: window.location.href
      }
    } } };
    return post('profiles', profilePayload).then(function () { return post('events', eventPayload); });
  }

  // Optional stylist follow-up: profile UPDATE only, reusing the already-captured email.
  // Never fires a second "Styled For You Completed" event.
  function submitFollowUp(state) {
    var props = { contact_preference: state.contactPreference };
    var attrs = { email: state.email, properties: props };
    if (state.contactPreference === 'CONTACT_WHATSAPP' && state.phone) {
      attrs.phone_number = state.phone;
      props.phone_wa = digitsOnly(state.phone);
    }
    return post('profiles', { data: { type: 'profile', attributes: attrs } });
  }

  function toQuizLook(l) {
    if (!l) return null;
    return {
      handle: l.handle,
      headline: l.headline || '',
      subheadline: l.sub || '',
      problemStatement: l.problem || '',
      image: l.image || ''
    };
  }

  function pickLook(allLooks, occasion, excludeHandle) {
    if (!allLooks || !occasion || !window.CaremaSFY) return null;
    var core = window.CaremaSFY;
    return toQuizLook(core.recommend(allLooks, core.normalize(occasion), { excludeHandle: excludeHandle || null }));
  }

  function initForm(container) {
    if (!isLookContext(container)) { container.style.display = 'none'; return; }
    var state = {
      step: 0, intent: null, occasion: null, travelPackingHelp: null,
      lookPref: null, stylePref: null, email: null, recommendedLook: null,
      contactPreference: null, phone: null
    };
    viewed();

    var looksPromise = new Promise(function (resolve) {
      if (!window.CaremaSFY) { resolve(null); return; }
      window.CaremaSFY.load().then(function (all) { resolve(all); }, function () { resolve(null); });
    });

    function render() {
      container.innerHTML = '';
      if (state.step === 0) renderIntro();
      else if (state.step === 1) renderQ1();
      else if (state.step === 2) renderTravelHelp();
      else if (state.step === 3) renderQ2();
      else if (state.step === 4) renderQ3();
      else if (state.step === 5) renderEmailGate();
      else if (state.step === 6) renderResult();
      else if (state.step === 7) renderContactPreference();
      else if (state.step === 8) renderPhone();
    }

    function makeQ(text) { var p = document.createElement('p'); p.className = 'sfy-question'; p.textContent = text; container.appendChild(p); }
    function makeOpts(items, fn) {
      items.forEach(function (item) {
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sfy-option'; btn.textContent = item.label;
        btn.addEventListener('click', function () { fn(item.value); }); container.appendChild(btn);
      });
    }

    function renderIntro() {
      var h = document.createElement('p'); h.className = 'sfy-headline'; h.textContent = 'Not sure what to wear?'; container.appendChild(h);
      var p = document.createElement('p'); p.className = 'sfy-intro'; p.textContent = 'Tell us where you\'re going and we\'ll put together a few outfit ideas for you.'; container.appendChild(p);
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sfy-submit'; btn.textContent = 'GET MY OUTFIT IDEAS';
      btn.addEventListener('click', function () { state.step = 1; render(); }); container.appendChild(btn);
    }
    function renderQ1() {
      makeQ("What's the occasion?");
      makeOpts(INTENT, function (val) {
        state.intent = val;
        ga4('sfy_form_started', { occasion: val });
        state.step = (val === 'INTENT_TRAVEL') ? 2 : 3;
        render();
      });
    }
    function renderTravelHelp() {
      makeQ('Need help packing for your trip?');
      makeOpts(TRAVEL_HELP, function (val) { state.travelPackingHelp = val; state.step = 3; render(); });
    }
    function renderQ2() {
      makeQ('How do you want to look?');
      makeOpts(LOOK_PREF, function (val) { state.lookPref = val; state.step = 4; render(); });
    }
    function renderQ3() {
      makeQ('Which one feels more like you?');
      makeOpts(STYLE_PREF, function (val) { state.stylePref = val; state.step = 5; render(); });
    }
    function renderEmailGate() {
      ga4('sfy_email_gate_reached', { occasion: state.intent });
      makeQ('Where should we send your recommendation?');
      var sub = document.createElement('p'); sub.className = 'sfy-subtext'; sub.textContent = "We'll use this to save your styling request."; container.appendChild(sub);
      var emailInput = document.createElement('input'); emailInput.type = 'email'; emailInput.placeholder = 'Your email'; emailInput.className = 'sfy-input'; emailInput.required = true; container.appendChild(emailInput);
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sfy-submit'; btn.textContent = 'SEE MY LOOK';
      btn.addEventListener('click', function () {
        if (!emailInput.validity.valid || !emailInput.value.trim()) { emailInput.reportValidity(); return; }
        btn.textContent = 'Finding your look\u2026'; btn.disabled = true;
        state.email = emailInput.value.trim();
        var occasion = INTENT_OCCASION_MAP[state.intent] || null;
        state.occasion = occasion;
        looksPromise.then(function (allLooks) {
          var look = pickLook(allLooks, occasion, container.getAttribute('data-current-look'));
          state.recommendedLook = look;
          submit({
            email: state.email,
            occasion: state.intent,
            lookPref: state.lookPref,
            stylePref: state.stylePref,
            travelHelp: state.travelPackingHelp,
            recommendedLookHandle: look ? look.handle : null
          })
          .then(function () {
            ga4('sfy_form_completed', { occasion: state.intent, look_pref: state.lookPref, style_pref: state.stylePref });
            state.step = 6; render();
          })
          .catch(function () { btn.textContent = 'SEE MY LOOK'; btn.disabled = false; });
        });
      }); container.appendChild(btn);
    }
    function renderResult() {
      ga4('sfy_result_step_reached', { intent: state.intent });
      var look = state.recommendedLook;
      var occasion = state.occasion;
      if (!look || !look.headline || !look.image) { renderFallback(occasion); return; }
      renderLookCard(look, occasion);
    }
    function renderFallback(occasion) {
      ga4('sfy_result_fallback', { occasion: occasion || 'unknown' });
      var msg = document.createElement('p'); msg.className = 'sfy-subtext'; msg.textContent = "We're still curating this edit \u2014 explore more looks below."; container.appendChild(msg);
      var url = occasion ? ('/pages/styled-for-you?occasion=' + encodeURIComponent(occasion)) : '/pages/styled-for-you';
      var link = document.createElement('a'); link.href = url; link.className = 'sfy-submit'; link.style.textDecoration = 'none'; link.style.textAlign = 'center'; link.style.boxSizing = 'border-box'; link.textContent = 'EXPLORE LOOKS';
      container.appendChild(link);
      var more = document.createElement('button'); more.type = 'button'; more.className = 'sfy-skip'; more.style.marginTop = '14px'; more.style.textAlign = 'center'; more.textContent = 'Want more options from a Carema stylist?';
      more.addEventListener('click', function () { state.step = 7; render(); }); container.appendChild(more);
    }
    function renderLookCard(look, occasion) {
      ga4('carema_look_recommended', { occasion_category: occasion, carema_look_handle: look.handle, intent: state.intent });

      var eyebrow = document.createElement('p'); eyebrow.className = 'sfy-result-eyebrow'; eyebrow.textContent = 'YOUR CAREMA LOOK'; container.appendChild(eyebrow);

      if (look.problemStatement) {
        var ps = document.createElement('p'); ps.className = 'sfy-question'; ps.style.textAlign = 'center'; ps.textContent = look.problemStatement; container.appendChild(ps);
      }

      var card = document.createElement('a');
      card.href = '/pages/looks/' + look.handle;
      card.className = 'sfy-result-card';
      card.addEventListener('click', function () { ga4('carema_look_clicked', { occasion_category: occasion, carema_look_handle: look.handle }); });

      var img = document.createElement('img');
      img.className = 'sfy-result-img'; img.src = look.image; img.alt = look.headline; img.loading = 'lazy';
      card.appendChild(img);

      var h = document.createElement('h3'); h.className = 'sfy-result-name'; h.textContent = look.headline; card.appendChild(h);

      if (look.subheadline) {
        var sub = document.createElement('p'); sub.className = 'sfy-result-sub'; sub.textContent = look.subheadline; card.appendChild(sub);
      }

      var cta = document.createElement('span'); cta.className = 'sfy-result-cta'; cta.textContent = 'DISCOVER THE LOOK'; card.appendChild(cta);
      container.appendChild(card);

      var more = document.createElement('button'); more.type = 'button'; more.className = 'sfy-skip'; more.style.textAlign = 'center'; more.style.marginTop = '4px'; more.textContent = 'Want more options from a Carema stylist?';
      more.addEventListener('click', function () { state.step = 7; render(); }); container.appendChild(more);
    }
    function renderContactPreference() {
      ga4('sfy_contact_pref_reached');
      makeQ('How would you like your stylist to reach you?');
      makeOpts(CONTACT_PREF, function (val) {
        state.contactPreference = val;
        ga4('sfy_contact_pref_selected', { preference: val });
        if (val === 'CONTACT_WHATSAPP') { state.step = 8; render(); }
        else { finishFollowUp(); }
      });
    }
    function renderPhone() {
      makeQ("What's the best WhatsApp number to reach you?");
      var sub = document.createElement('p'); sub.className = 'sfy-subtext'; sub.textContent = "We'll use this only to help with your styling request."; container.appendChild(sub);
      var phoneInput = document.createElement('input'); phoneInput.type = 'tel'; phoneInput.placeholder = 'Your WhatsApp number (e.g. +1 305 555 1234)'; phoneInput.className = 'sfy-input'; container.appendChild(phoneInput);
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sfy-submit'; btn.textContent = 'Send';
      btn.addEventListener('click', function () { state.phone = phoneInput.value.trim(); finishFollowUp(); });
      container.appendChild(btn);
    }
    function finishFollowUp() {
      submitFollowUp(state)
        .then(function () { ga4('sfy_stylist_followup_requested', { contact_preference: state.contactPreference }); container.innerHTML = '<p class="sfy-success">Perfect. A Carema stylist will be in touch.</p>'; })
        .catch(function () { container.innerHTML = '<p class="sfy-success">Perfect. A Carema stylist will be in touch.</p>'; });
    }
    render();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sfy-form]').forEach(function (el) { initForm(el); });
  });

})();
